<template>
<div class="chapter">
<div class="inner_page">
<p class="para"> </p>
<p class="para"> </p>
<p class="para"> </p>
<p class="para">Born to an American musician father, and English mother, <strong>Jemma Wayne</strong> grew up in Hertfordshire and studied Social and Political Sciences at Cambridge University and Broadcast Journalism at the University of Westminster. She began her career as a journalist at The Jewish Chronicle, and later as a columnist for The Jewish News. She is now a regularly featured blogger at The Huffington Post and continues to contribute to a variety of other publications. Her first play, <em>Negative Space</em>, was staged in 2009 at Hampstead’s New End Theatre, receiving critical acclaim.</p>
<p class="indent-para1">Jemma’s debut novel <em>After Before</em> was longlisted for the Baileys Women’s Prize for Fiction, longlisted for the Guardian Not the Booker Prize and shortlisted for the Waverton Good Read Award.</p>
<p class="para"> </p>
<p class="center">Visit Jemma at</p>
<p class="center"><a href="http://jemmawayne.com" target="_blank">jemmawayne.com</a></p>
<p class="center">or on Twitter</p>
<p class="center"><a href="https://twitter.com/writejemmawayne" target="_blank">@writejemmawayne</a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// fm01.vue?3320ef97